import axios from "axios";
// import Message from "element-ui/packages/message/src/main";
import { message } from "@/utils/resetMessage";
import rewriteURL from "./rewriteURL";

// 创建axios实例
const service = axios.create({
  timeout: 60000 // 请求超时时间
});

// request拦截器
service.interceptors.request.use(
  config => {

    // 多域名重写路径
    config.url = rewriteURL(config);
    if (localStorage.getItem("Authorization")) {
      config.headers.Authorization = localStorage.getItem("Authorization"); // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    return config;
  },
  error => {
    // Do something with request error
    console.log(error); // for debug
    Promise.reject(error);
  }
);

// 响应拦截  401 token过期处理
service.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    // 错误提醒
    // Message.error(error.response.data)
    // localStorage.removeItem("Authorization");
    // localStorage.removeItem("userInfo");
    // localStorage.setItem("isLogin", false);
    // localStorage.setItem("isActive", 0);
    // message.success("退出登录");
    // setTimeout(() => {
    //     window.location.href = '/'
    // }, 2000);

    if (window.location.hash == "#/member") {
    } else if (error.response && (error.response.status == 401 || error.response.status == 422)) {
      // localStorage.removeItem("Authorization");
      // localStorage.removeItem("userInfo");
      // localStorage.setItem("isLogin", false);
      // localStorage.setItem("isActive", 0);
      // message.success("退出登录");
      // setTimeout(() => {
      //     window.location.href = '/'
      // }, 2000);
      if (error.response.data.error == "Token 不存在") {
        localStorage.removeItem("Authorization");
        localStorage.removeItem("userInfo");
        localStorage.setItem("isLogin", false);
        localStorage.setItem("isActive", 0);
        setTimeout(() => {
          window.location.href = "/";
        }, 2000);
        message.error("未登录，请先登录");
      } else if (
        error.response.data.error ==
        "您的账号已在另一台设备上登录，若非本人登录请重新登陆后尽快修改密码"
      ) {
        localStorage.removeItem("Authorization");
        localStorage.removeItem("userInfo");
        localStorage.setItem("isLogin", false);
        localStorage.setItem("isActive", 0);
        message.success(
          "您的账号已在另一台设备上登录，若非本人登录请重新登陆后尽快修改密码"
        );
        window.location.href = "/";
      } else if (error.response.data.error == "登录信息已过期") {
        localStorage.removeItem("Authorization");
        localStorage.removeItem("userInfo");
        localStorage.setItem("isLogin", false);
        localStorage.setItem("isActive", 0);
        setTimeout(() => {
          window.location.href = "/";
        }, 2000);
        message.error(error.response.data.error);
      } else {
        message.error(error.response.data.error);
      }
      // message.warning('未登录，请先登录!')
      //   // 清除token
      //   localStorage.removeItem('eleToken')
      //
      //   // 页面跳转
      //   router.push('/login')
    }
    //
    return Promise.reject(error);
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js